import { concatMap } from "rxjs";
import generateSecureToken from "../../../utils/generateSecureToken";
import { apiService } from "../../ApiService";

export type UpdatePaymentMethodFormData = {
  paymentMethod: unknown;
};

export const stripeUpdatePaymentMethod = (
  paymentMethod: UpdatePaymentMethodFormData,
) => {
  return generateSecureToken(apiService.userAgent).pipe(
    concatMap((secureToken) => {
      return apiService.put<{ secret: string | undefined }>({
        path: `v1/store/blacknut/payment-method`,
        body: paymentMethod,
        secureToken,
      });
    }),
  );
};
